module.exports = __webpack_public_path__ + "static/media/three.b98bcb66.jpeg";